<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :label-width="80">
				<FormItem label="设备编号" class="sj">
					<Input v-model="formValidate.id" placeholder="请输入设备编号" disabled></Input>
				</FormItem>
				<FormItem label="负责人" class="sj">
					<Input v-model="formValidate.experiencePhone" placeholder="请输入手机号" ></Input>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	export default {
		data() {
			return {
				formValidate: {
					experiencePhone: '',
					id: ''
				},
				macId:''
			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/update/phone',
				    data: _this.formValidate,
					_this: _this,
					success: function(data) {
						_this.$Message.success('修改成功!');
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			ajax() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fac/mac/leave/factory/findById',
				    data: {
						id:_this.macId
					},
					_this: _this,
					success: function(data) {
						_this.formValidate = data.macLeaveFactory
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		},

		created() { //请求数据
			this.macId = this.$route.query.operMacId
			this.ajax();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/mac/updatePhone.vue